import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FooterMain as FooterMainComponent } from './footer-main';
import { footerDataSelector } from './tenant-specific-selectors';
const mapStateToProps = createStructuredSelector({
  footerData: footerDataSelector
});
export const FooterMain = connect(mapStateToProps)(FooterMainComponent);